module.exports = __webpack_public_path__ + "img/zubut-logo-blue.png";